import Logger from '../appl/logger'

/* tslint:disable no-magic-numbers */
const DEFAULT_MARGIN = 1_000
const DEFAULT_THRESHOLD = [0, 0.1]
/* tslint:enable no-magic-numbers */

const DEFAULT_OPTION = {
    rootMargin: `${DEFAULT_MARGIN}px`,
    threshold: DEFAULT_THRESHOLD,
}

function isLazyLoadOption(obj: boolean | object) {
    if (typeof obj === 'boolean') return false
    return 'rootMargin' in obj || 'threthold' in obj
}

function toIntersectionObserverInitOption(obj: boolean | LazyLoadOption | undefined) {
    if (!obj || !isLazyLoadOption(obj)) return DEFAULT_OPTION
    const option = obj as LazyLoadOption
    const rootMargin = option.rootMargin === 0 ? 0 : option.rootMargin || DEFAULT_MARGIN
    return {
        rootMargin: `${rootMargin}px`,
        threshold: option.threshold || DEFAULT_THRESHOLD,
    }
}

/**
 * IntersectionObserver を利用した遅延表示広告枠の監視クラス。
 */
export class IntersectionLazyLoadObserver implements LazyLoadObserver {
    /**
     * 遅延表示広告枠の監視を開始する。
     * @param slot 遅延表示広告枠定義
     * @param callback 遅延表示条件を満たした際に実行されるコールバック関数
     */
    public observe(slot: SlotDefinition, callback: ObserverCallback) {
        const target = document.getElementById(slot.id)
        if (target === null) {
            callback(null)
            return
        }
        const observer = this.createObserver(slot, callback)
        Logger.debug(`遅延表示監視開始 [${target.id}]`, target)
        observer.observe(target)
    }

    private createObserver(slot: SlotDefinition, callback: ObserverCallback) {
        const options = toIntersectionObserverInitOption(slot.lazyLoad)
        Logger.debug(`遅延表示オプション [${slot.id}]`, options)
        return new IntersectionObserver(this.onInteresting(slot, callback), options)
    }

    private onInteresting(slot: SlotDefinition, handler: ObserverCallback) {
        return (entries: IntersectionObserverEntry[], observer: IntersectionObserver) => {
            entries
                .filter(entry => entry.intersectionRatio > 0)
                .forEach(entry => {
                    observer.unobserve(entry.target)
                    handler(slot)
                    Logger.debug(`遅延表示広告が表示されました [${slot.id}]`, entry)
                })
        }
    }
}

export default class IntersectionLazyLoadObserverFactory implements LazyLoadObserverFactory {
    public create() {
        return new IntersectionLazyLoadObserver()
    }
}
